import { render, staticRenderFns } from "./BiddersModal.vue?vue&type=template&id=3aee2034&scoped=true"
import script from "./BiddersModal.vue?vue&type=script&lang=js"
export * from "./BiddersModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aee2034",
  null
  
)

export default component.exports